export enum PlanType {
  pro = 'pro',
  free = 'free',
}

export interface PlanDetails {
  buttonText: string;
  features: string[];
  featuresTitle: string;
  price: string;
  title: string;
  videosCount: number;
  credits: number;
}

export interface Plan {
  id: string;
  name: string;
  type: PlanType;
  details: PlanDetails;
  order?: number;
}
